import styled from 'styled-components'
import { fontWeights } from '@/styles'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`

const Label = styled.span`
  flex: 1;
  margin-right: 28px;
`

const Value = styled.span`
  flex: 1;
  justify-content: flex-end;
  font-weight: ${fontWeights.medium};
  text-align: right;
`

type LabeledProps = { label: string; value: string }

const LabeledValue: React.FC<LabeledProps> = ({ label = '', value = '', ...rest }) => (
  <Wrapper {...rest}>
    <Label>{label}</Label>
    <Value>{value}</Value>
  </Wrapper>
)

export default LabeledValue
